import { render } from "./SettingsOrganizationView.vue?vue&type=template&id=57ba7fa4"
import script from "./SettingsOrganizationView.vue?vue&type=script&lang=js"
export * from "./SettingsOrganizationView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/SettingsOrganizationView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57ba7fa4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57ba7fa4', __exports__)) {
    api.reload('57ba7fa4', __exports__)
  }
  
  module.hot.accept("./SettingsOrganizationView.vue?vue&type=template&id=57ba7fa4", () => {
    api.rerender('57ba7fa4', render)
  })

}


export default __exports__